<template>
<div class="honor_carousel">
    <!-- <div class="prev_btn" @click="prev"></div> -->

    <div class="big-wapper" style="overflow: hidden">
        <div class="carousel_container">
            <el-carousel :interval="5000" arrow="never" class="carousel_con" ref="honorCarousel">
                <el-carousel-item v-for="(item,index) in honorList" :key=index>
                    <div class="bigItem">
                        <el-row :gutter="15">
                            <el-col :span="5" v-for="(itemInnter,index) in item" :key="index">
                                <div class="position">
                                    <div>
                                        <img :src="itemInnter.imageUrl" alt="" width="230" height="270" />
                                    </div>
                                    <div class="position_name">{{itemInnter.honorName}}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
    <!-- <div class="next_btn" @click="next"></div> -->
</div>
</template>

<script>
import {
    GetHonor
} from '../views/Home/Home.model';
export default {
    name: "HonorCarousel",
    data() {
        return {
            honorList: []
        }
    },
    methods: {
        prev() {
            this.$refs.honorCarousel.prev();
        },
        next() {
            this.$refs.honorCarousel.next();
        }
    },
    async mounted() {
        let param = {
            page: 1,
            limit: 0
        };
        let honorData = await GetHonor(param);
        //console.log("===honorData===", honorData)
        var tempContainer = [];
        honorData.data.list.forEach(function (item, index) {
            var num = Math.floor(index / 5);
            if (!tempContainer[num]) {
                tempContainer[num] = [];
            }
            tempContainer[num].push(item);
        });
        this.honorList = tempContainer;
    }
}
</script>

<style lang="less" scoped>
.prev_btn {
    margin: 24px auto;
    width: 32px;
    height: 22px;
    background: url("~@/assets/image/joinus_up.png") no-repeat center center;
    background-size: contain;

    &:hover {
        background: url("~@/assets/image/joinus_up_hover.png") no-repeat center center;
        background-size: contain;
    }
}

.next_btn {
    margin: 24px auto;
    width: 32px;
    height: 22px;
    background: url("~@/assets/image/joinus_down.png") no-repeat center center;
    background-size: contain;

    &:hover {
        background: url("~@/assets/image/joinus_down_hover.png") no-repeat center center;
        background-size: contain;
    }
}

.honor_carousel {
    //position: absolute;
    //right: 70px;
    width: 1240px;
    padding-top: 15px;
}

.big-wapper {
    //background-color: #fff;
    padding: 0px;
    height: 320px;
}

.carousel_container {
    font-size: 14px;
    height: 100%;

    .el-col-5 {
      width: 20%;
    }

    img {
        text-align: center;
    }

    .position {
        float: left;
        text-align: center;
        overflow: hidden;
    }

    .carousel_con {
        height: 100%;
    }

    .bigItem {
        width: 100%;
        height: 320px
    }

    .position_name {
        color: #333;
        font-size: 14px;
        margin-top: 4px;
    }

}
</style>
